module.exports = __webpack_public_path__ + "img/bg_intro_02.46375bc4.png";